import React from "react";
import { ListGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinusCircle} from "@fortawesome/free-solid-svg-icons";
import TextSlider from "../textSlider";


export default function RulesEditStructLengthEntry(props) {
    function setPoints(val){
        props.data.grading = val;
        // const newData = {add2G: val,percentage: props.data.percentage,threshold: props.data.threshold,ruleType: "struct2GSrules"};
        props.cb(props.data);
    }
    function setDistance(val) {
        props.data.threshold = val;
        props.cb(props.data);
    }

    return (
                <ListGroup.Item className="d-flex justify-content-between align-items-start">
                    <span>
                        Penalise grade by
                    <TextSlider
                        min={0}
                        max={100}
                        value={props.data.grading}
                        onChange={setPoints}
                        display={(value) => <span> ( {value} ) points</span>}
                    />
                    if there are
                    <TextSlider
                        min={0}
                        max={10}
                        rate={0.1}
                        value={props.data.threshold}
                        onChange={setDistance}
                        display={(value) => <span>( {value} ) extra slices</span>}
                    />
                    </span>

                    <button onClick={() => props.cb(null)} className="ms-2 btn btn-link text-danger">
                        <FontAwesomeIcon className="pe-auto" icon={faMinusCircle} />
                    </button>
                </ListGroup.Item>


    )
}